import React from 'react';

export default function Logout({ props }: any) {
    return (
        <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M1 5.44444V3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V15C15 16.1046 14.1046 17 13 17H3C1.89543 17 1 16.1046 1 15V12.5556" stroke="#EA400E" strokeLinecap="round" />
            <path d="M5 6L8 9L5 12" stroke="#EA400E" strokeLinecap="round" />
            <path d="M1 9H8" stroke="#EA400E" strokeLinecap="round" />
        </svg>
    );
}